// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 导入element组件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css'
import dataV from '@jiaminghi/data-view'
import echarts from 'echarts'
// import VueQr from 'vue-qr'
import scroll from 'vue-seamless-scroll'
import network from '@/api/network'
import 'default-passive-events'
import yhpczl from '@/api/yhpc'
import location from '@/api/location'
import vueFilter from '@/api/fifter'
import filters from '@/api/filters'
// 防止用户在一定时间内重复频繁的触发事件
import preventReClick from '@/store/preventReClick.js'
import store from '@/store/index'
import Viewer from 'v-viewer'
Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    const ariaEls = el.querySelectorAll('.el-radio__original')
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden')
    })
  }
})
// import 'viewerjs/dist/viewer.css'
// require('video.js/dist/video-js.css');
// require('vue-video-player/src/custom-theme.css');
// import VideoPlayer from 'vue-video-player'
// Vue.use(VideoPlayer);
// import videojs from 'video.js';
// import 'video.js/dist/video-js.css';
// Vue.prototype.$video = videojs;
import './plugins/video'
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 999
  }
})
// import VideoPlayer from 'vue-video-player'
// Vue.use(VideoPlayer)
// require('vue-video-player/src/custom-theme.css')
Vue.prototype.checkNullb = function (a) {
  var reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*_.-]).{8,20}$/
  if (!reg.test(a)) {
    return true
  } else {
    console.log('此项必须包含大小写字母和数字的组合，不能使用特殊字符，长度在8-10之间!')
    return false
  }
}
Vue.prototype.$echarts = echarts
Vue.use(scroll)
Vue.prototype.$network = network
Vue.prototype.$yhpczl = yhpczl
Vue.prototype.$location = location
Vue.prototype.$filter = filters
for (let key in vueFilter) {
  Vue.filter(key, vueFilter[key])
}
// filters
Vue.use(preventReClick)
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(dataV)
// import axios from 'axios'
// Vue.prototype.$http = axios
/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  // VueQr,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js